/* ZilZal global transitions (by Claude)
   Smooth click -> product page: card press-in + dark fade, then navigate.
   Defers to the theme's native product image morph (product-card-link) when enabled.
   Remove this file + its include in layout/theme.liquid to revert. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getOverlay() {
    var o = document.querySelector('.bxc-page-fade');
    if (!o) {
      o = document.createElement('div');
      o.className = 'bxc-page-fade';
      document.body.appendChild(o);
    }
    return o;
  }

  document.addEventListener('click', function (e) {
    if (reduced.matches) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href*="/products/"]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;
    if (a.closest('product-card-link')) return; /* native view-transition morph handles this click */

    e.preventDefault();
    var card = a.closest('.bxc-card, product-card, .resource-card');
    if (card) card.classList.add('is-leaving');
    var o = getOverlay();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { o.classList.add('is-on'); });
    });
    setTimeout(function () { window.location.href = a.href; }, 230);
  });

  /* Back/forward cache: clean up so the page is never stuck faded */
  window.addEventListener('pageshow', function () {
    var o = document.querySelector('.bxc-page-fade');
    if (o) o.classList.remove('is-on');
    document.querySelectorAll('.is-leaving').forEach(function (el) { el.classList.remove('is-leaving'); });
  });
})();

/* ZilZal hero carousel fix (by Claude): non-active cards center on tap (robust tap-vs-swipe) + RTL-correct nav arrow glyphs. Patches the hero from outside so the section file is untouched. */
(function () {
  function fixArrows(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.zilzal-hero-wrapper [data-zh-prev]'), function (b) { b.innerHTML = '\u203A'; });
    Array.prototype.forEach.call(root.querySelectorAll('.zilzal-hero-wrapper [data-zh-next]'), function (b) { b.innerHTML = '\u2039'; });
  }
  var downX = 0, downY = 0, moved = 0;
  function onDown(e) { var p = e.touches ? e.touches[0] : e; if (!p) return; downX = p.clientX; downY = p.clientY; moved = 0; }
  function onMove(e) { var p = e.touches ? e.touches[0] : e; if (!p) return; var dx = p.clientX - downX, dy = p.clientY - downY; var d = Math.sqrt(dx * dx + dy * dy); if (d > moved) moved = d; }
  document.addEventListener('mousedown', onDown, true);
  document.addEventListener('touchstart', onDown, true);
  document.addEventListener('mousemove', onMove, true);
  document.addEventListener('touchmove', onMove, true);

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.zilzal-hero-wrapper [data-zh-card]');
    if (!card) return;
    if (moved > 40) return;
    if (card.classList.contains('is-active')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var carousel = card.closest('[data-zh-carousel]');
    if (!carousel) return;
    var cards = Array.prototype.slice.call(carousel.querySelectorAll('[data-zh-card]'));
    var n = cards.length;
    if (!n) return;
    var clicked = cards.indexOf(card);
    var activeEl = carousel.querySelector('[data-zh-card].is-active');
    var active = activeEl ? cards.indexOf(activeEl) : 0;
    var half = Math.floor(n / 2);
    var delta = clicked - active;
    while (delta > half) delta -= n;
    while (delta < -half) delta += n;
    if (delta === 0) return;
    var row = carousel.parentElement || carousel;
    var nextBtn = row.querySelector('[data-zh-prev]');
    var prevBtn = row.querySelector('[data-zh-next]');
    var b = delta > 0 ? nextBtn : prevBtn;
    var times = Math.abs(delta);
    if (b) { for (var i = 0; i < times; i++) { b.click(); } }
  }, true);

  function boot() { fixArrows(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ZilZal cart trigger + fly (by Claude). DESKTOP (>=750px): render the cart trigger as a vertical side TAB pinned to the LEFT edge, and open the drawer from the LEFT to match the RTL layout. ALL viewports: fly the product image into the cart trigger when the store's add buttons ([data-bxp-add] / [data-bxc-add]) are clicked. Mobile/tablet keep their existing bottom pill; only the fly animation is added there. */
(function () {
  var css = '@media (min-width:750px){'
    + '#zzfc-root{left:0 !important;right:auto !important;top:50% !important;bottom:auto !important;transform:translateY(-50%) !important;}'
    + '#zzfc-root[data-empty=true],#zzfc-root.zzcart-open{transform:translateY(-50%) translateX(-100%) !important;opacity:0 !important;visibility:hidden !important;pointer-events:none !important;}'
    + '#zzfc{flex-direction:column !important;gap:9px !important;padding:15px 10px !important;border-radius:0 16px 16px 0 !important;}'
    + '#zzfc .zzfc__icon svg{width:24px !important;height:24px !important;}'
    + '#zzfc .zzfc__text{writing-mode:vertical-rl !important;text-orientation:mixed !important;font-size:13px !important;font-weight:800 !important;letter-spacing:1px !important;}'
    + '#zzfc .zzfc__total{display:none !important;}'
    + '#zzcart{left:0 !important;right:auto !important;transform:translateX(-100%) !important;border-inline-start:0 !important;border-inline-end:1px solid rgba(107,76,255,.3) !important;box-shadow:26px 0 70px rgba(0,0,0,.6) !important;}'
    + '#zzcart.is-open{transform:translateX(0) !important;}'
    + '}';
  var st = document.createElement('style');
  st.setAttribute('data-zzfc-desktop', '1');
  st.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(st);

  function pillEl() { return document.getElementById('zzfc'); }
  function findImg(btn) {
    var card = btn.closest('.bxc-card, .grid__item, product-card, .product-card, .card-product, li');
    var img = card && card.querySelector('img');
    if (!img) img = document.querySelector('.bxp-gallery img, .bxp-media img, .product__media img, product-media img, .product-media img, main img');
    return img;
  }
  function flyImg(img) {
    var p = pillEl();
    if (!img || !img.src || !p) return;
    var s = img.getBoundingClientRect(), t = p.getBoundingClientRect();
    if (!s.width || !t.width) return;
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.style.cssText = 'position:fixed;z-index:9999;border-radius:14px;object-fit:cover;pointer-events:none;box-shadow:0 10px 30px rgba(0,0,0,.4);will-change:transform,opacity;left:' + s.left + 'px;top:' + s.top + 'px;width:' + s.width + 'px;height:' + s.height + 'px;transition:transform .75s cubic-bezier(.5,-0.2,.3,1),opacity .75s ease;';
    document.body.appendChild(clone);
    var dx = (t.left + t.width / 2) - (s.left + s.width / 2), dy = (t.top + t.height / 2) - (s.top + s.height / 2);
    requestAnimationFrame(function () { requestAnimationFrame(function () { clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(8deg)'; clone.style.opacity = '0.35'; }); });
    setTimeout(function () { if (clone.parentNode) clone.parentNode.removeChild(clone); var pl = pillEl(); if (pl) { pl.classList.remove('is-bump'); void pl.offsetWidth; pl.classList.add('is-bump'); } }, 800);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bxp-add], [data-bxc-add]');
    if (!btn || btn.disabled) return;
    if (btn.classList && btn.classList.contains('bxc-card__add--choose')) return;
    var img = findImg(btn);
    if (img) flyImg(img);
  }, true);
})();
